import type { ChatSubagentCard } from "../ui-types.ts";
import type { SessionSnapshot } from "./session-snapshot.ts";

export type ChatSessionChildrenProps = {
  chatSessionSnapshot?: SessionSnapshot | null;
  chatSubagents?: ChatSubagentCard[];
};

/**
 * UX-PLAN Pillar D — single source of truth for "which children is
 * this session currently showing". Reads from `chatSessionSnapshot`
 * when the parent supplied a snapshot, otherwise falls back to the
 * legacy `chatSubagents` array.
 */
export function sessionChildren(props: ChatSessionChildrenProps): ChatSubagentCard[] {
  return props.chatSessionSnapshot?.children ?? props.chatSubagents ?? [];
}
